(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pe-gift-invitation"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pe-gift-slideshow')) {
  customElements.define('pe-gift-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (this.slides.length < 2) return;
      this.index = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.visible = false;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelector('.pe-gift-controls').hidden = false;
      this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), options);
      this.querySelector('[data-pause]').addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold: 0.25 });
      this.observer.observe(this);
      this.updatePause();
    }
    updatePause() {
      const button = this.querySelector('[data-pause]');
      button.textContent = this.paused ? '▶' : 'Ⅱ';
      button.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
      button.setAttribute('aria-pressed', String(this.paused));
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== this.index)));
      this.querySelector('[data-counter]').textContent = (this.index + 1) + ' / ' + this.slides.length;
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.paused && !this.focused && this.visible && !document.hidden) this.timer = setTimeout(() => this.show(this.index + 1), 5000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.controller?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pe-home-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pe-home-slideshow')) {
  customElements.define('pe-home-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (this.slides.length < 2) return;
      this.index = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.visible = false;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelector('.pe-home__slide-controls').hidden = false;
      this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), options);
      this.querySelector('[data-pause]').addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold: 0.25 });
      this.observer.observe(this);
      this.updatePause();
    }
    updatePause() {
      const button = this.querySelector('[data-pause]');
      button.textContent = this.paused ? '▶' : 'Ⅱ';
      button.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      button.setAttribute('aria-pressed', String(this.paused));
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== this.index)));
      this.querySelector('[data-counter]').textContent = (this.index + 1) + ' / ' + this.slides.length;
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.paused && !this.focused && this.visible && !document.hidden) this.timer = setTimeout(() => this.show(this.index + 1), 5000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.controller?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
